import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "../components/Card.jsx";
import RepoForm from "../components/RepoForm.jsx";
import { repoApi } from "../../api/repoApi";
import { getApiError } from "../../api/client";
import "../styles/codebase.css";

export default function RepoAddPage() {
  const nav = useNavigate();
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (payload) => {
    setErr("");
    setSaving(true);
    try {
      const res = await repoApi.create(payload);
      nav(`/codebase/repos/${res.data.id}`);
    } catch (e) {
      setErr(getApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cb-page">
      <div className="page-head">
        <div>
<h2>
        Add Repository</h2></div>
          <div className="muted">
            Create a scan target (Git repo or system source). Secrets are stored in Connections and never returned to UI.
          </div>
    

        <div className="page-actions">
          <Link className="btn ghost" to="/codebase/repos">
            Back
          </Link>
        </div>
      </div>

      {err && <div className="error">{err}</div>}

      <Card title="Repository details">
        <RepoForm onSubmit={submit} submitting={saving} submitLabel="Create" />
      </Card>
    </div>
  );
}
